import { useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { useEffect, useState } from "react";
import StepRoutes from "../../../Routes/steps_routes";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
// import KryzenTop from "../SI PDF Tables/kryzen_Top";
import AIFKryzenTop from "../SI PDF Tables/aif_kryzen_top";
// import SIReport from "../SI PDF Tables/si_report";
import AIFSIReport from "../SI PDF Tables/aif_si_report";
// import SIDetails from "../SI PDF Tables/si_details";
import AIFSIDetails from "../SI PDF Tables/aif_si_details";
import Products from "../SI PDF Tables/products";
import { getId } from "../../../Components/Functions/word.fun";
import ProduceTable from "../SI PDF Tables/plants_can_grow";
// import SWOT from "../SI PDF Tables/swot";
import AIFSWOT from "../SI PDF Tables/aif_swot";
import FinancialAnalysis from "../SI PDF Tables/financial_analysis";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import KryzenTopQuot from "../../Quatation/PdfQuotationsTables/kryzen_Top";
import QuotationAmounts from "../../Quatation/PdfQuotationsTables/quotation_amounts";
import QuotationAmountsV2 from "../../Quatation/PdfQuotationsTablesV2/quotation_amounts";
import BorrowFromBankSchedule2 from "../SI PDF Tables/Borrow From Bank/schedule_2_borrow";
import PaymentBreakdown from "../../Quatation/PdfQuotationsTables/payment_breakdown";
import PaymentBreakdownV2 from "../../Quatation/PdfQuotationsTablesV2/payment_breakdown";

const SiteInspectionPreviewAIF = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [allQData, setAllQData] = useState();
  const [image, setImage] = useState("visible");
  const printPDF = () => {
    let name = "aif-project-report";
    if (
      data &&
      (data?.clientDetails?.businessName || data?.clientDetails.clientName)
    ) {
      name = `aif-project-report-${id}-${(
        data?.clientDetails?.businessName || data?.clientDetails.clientName
      )
        .split(" ")
        .join("-")
        .toLowerCase()}`;
    }
    document.title = name;

    window.print();
  };

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/siteInspection/getSiteInspectionById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting SI!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);
  useEffect(() => {
    data &&
      (data?.aifQuotationNumber || data?.quotationNumber) &&
      performRequest(
        "GET",
        `/quotations/getQuotationsById/${getId(
          data?.aifQuotationNumber || data?.quotationNumber
        )}`
      )
        .then((res) => {
          setLoading(true);
          if (res.status === 200) {
            let quotationData = res.data;
            let newOpexLabourConst =
              +data?.newSiteInspection?.averageLabourSalary *
              quotationData?.labourCount;
            let newAllOpexCost =
              quotationData?.opex_cost?.opex_all_cost -
              quotationData?.opex_cost?.opex_labour_cost +
              +newOpexLabourConst;
            quotationData = {
              ...quotationData,
              opex_cost: {
                ...quotationData.opex_cost,
                opex_all_cost: newOpexLabourConst
                  ? newAllOpexCost
                  : quotationData?.opex_cost?.opex_all_cost,
                opex_labour_cost:
                  newOpexLabourConst ||
                  quotationData?.opex_cost?.opex_labour_cost,
              },
            };
            setAllQData(quotationData);
            // setAllQData(res.data);
          } else {
            Toast("error", "Error while getting Quotations!");
          }
        })
        .catch((err) => {
          // Toast("error", "Server Error!");
          // console.error(err);
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
  }, [data]);
  useEffect(() => {
    if (allQData?.input_info?.isGrowSlab)
      setTimeout(() => {
        const element = document.getElementById("pdf-content");
        element.innerHTML = element.innerHTML.replace("GROW-BAG", "GROW-SLAB");
        element.innerHTML = element.innerHTML.replace("Grow bag", "Grow slab");
        element.innerHTML = element.innerHTML.replace(
          "grow bags",
          "grow slabs"
        );
        element.innerHTML = element.innerHTML.replace(
          "Grow bags",
          "Grow slabs"
        );
        element.innerHTML = element.innerHTML.replace(
          "Grow Bags",
          "Grow Slabs"
        );
        element.innerHTML = element.innerHTML.replace("Grow Bag", "Grow Slab");
        element.innerHTML = element.innerHTML.replace("Growbag", "Growslab");
        element.innerHTML = element.innerHTML.replace("Growbags", "Growslabs");
        element.innerHTML = element.innerHTML.replace("growbags", "growslabs");
      }, 1000);
  }, [allQData]);
  const goBack = () => {
    window.history.back();
  };
  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div
            className="page-header d-print-none"
            style={{ borderBottom: "1px solid #181818", marginBottom: "20px" }}
          >
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title"> Site Inspection</h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
              <div className="col-auto ms-auto d-print-none">
                <div className="d-flex">
                  <SimpleButton buttonText={"Save Pdf"} onClick={printPDF} />
                  <button class="btn mx-1 mt-2 btn-primary" onClick={goBack}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-left"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M5 12l14 0" />
                      <path d="M5 12l6 6" />
                      <path d="M5 12l6 -6" />
                    </svg>
                    BACK
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            className="card-body"
            style={{ color: "black", fontSize: "17px" }}
          >
            <div id="pdf-content">
              {data && allQData && (
                <AIFKryzenTop data={data} allQData={allQData} />
              )}
              {/* {data && allQData && (
              <TableOfContent allQData={allQData} data={data} />
            )} */}
              {data && allQData && (
                <AIFSIReport allQData={allQData} data={data} />
              )}
              {data && allQData && (
                <AIFSIDetails data={data} allQData={allQData} />
              )}
              {/* <PossibleDimentions /> */}

              <Products />

              {data &&
                allQData &&
                allQData?.input_info?.quotationType !== "fanpad" &&
                allQData?.input_info?.quotationType !== "nvph" &&
                allQData?.input_info?.quotationType !== "nethouse" &&
                allQData?.input_info?.quotationType !== "soilbasedfanpad" &&
                allQData?.input_info?.quotationType !== "soilbasednvph" &&
                allQData?.input_info?.quotationType !== "soilbasednethouse" && (
                  <>
                    <ProduceTable allQData={allQData} />
                    <div
                      className="html2pdf__page-break"
                      style={{
                        pageBreakAfter: "always",
                        display: "block",
                        clear: "both",
                      }}
                    ></div>
                  </>
                )}

              <div className="card-body" id="pdf-content">
                {/* <KryzenTopQuot />
                {data && allQData && (
                  <CompanyDescription
                    allQData={allQData}
                    businessName={
                      allQData?.input_info?.businessName ||
                      allQData?.input_info?.contactPersonName
                    }
                    address={allQData?.input_info?.address}
                    data={allQData}
                    quotationType={allQData?.input_info?.quotationType}
                  />
                )}
                {allQData && (
                  <UserDetails
                    userInfo={allQData?.input_info}
                    area={allQData?.area_in}
                    image={image}
                  />
                )}
                {allQData &&
                  allQData?.input_info?.quotationType === "fanpad" && (
                    <FanPadSpecifications />
                  )}

                {allQData &&
                  allQData?.input_info?.quotationType ===
                    "fanpad with hydroponics" && <FanPadSpecifications />}
                {allQData &&
                  allQData?.input_info?.quotationType === "nethouse" && (
                    <NetHouseSpecifications />
                  )}
                {allQData &&
                  allQData?.input_info?.quotationType ===
                    "nethouse with hydroponics" && <NetHouseSpecifications />}
                {allQData && allQData?.input_info?.quotationType === "nvph" && (
                  <NVPHSpecifications />
                )}
                {allQData &&
                  allQData?.input_info?.quotationType ===
                    "nvph with hydroponics" && <NVPHSpecifications />}
                {/* percent wise setup */}
                {/* {allQData?.input_info?.quotationType !== "fanpad" &&
                  allQData?.input_info?.quotationType !== "nvph" &&
                  allQData?.input_info?.quotationType !== "nethouse" && (
                    <>
                      {allQData && allQData?.input_info?.flatBedPercent > 0 && (
                        <FlatBedSetup />
                      )}
                      {allQData && allQData?.input_info?.a_FramePercent > 0 && (
                        <AFrameSetup />
                      )}
                      {allQData && allQData?.input_info?.growBagPercent > 0 && (
                        <GrowBagSetup />
                      )}
                      {allQData &&
                        allQData?.input_info?.dutchBucketPercent > 0 && (
                          <DutchBucketSetup />
                        )}
                      <div
                        className="html2pdf__page-break"
                        style={{
                          pageBreakAfter: "always",
                          display: "block",
                          clear: "both",
                        }}
                      ></div>
                    </>
                  )}

                {allQData && (
                  <WaterStorage_Handling
                    quotationType={allQData?.input_info?.quotationType}
                  />
                )}
                {allQData && <ElectricFittings data={allQData?.input_info} />}
                {allQData?.input_info?.quotationType !== "fanpad" &&
                  allQData?.input_info?.quotationType !== "nvph" &&
                  allQData?.input_info?.quotationType !== "nethouse" && (
                    <>
                      <EmployeeTrainingProgramme />
                      <AgronomySupport />
                    </>
                  )}
                <TrackingOfProgress image={image} />

                {allQData && (
                  <ScopeOfWork
                    quotationType={allQData?.input_info?.quotationType}
                    image={image}
                  />
                )}
                <CustomerResponsibility image={image} />
                <CivilMaterials image={image} /> */}
                {/* working panding */}
                {/* <AfterSalesServices_AMC /> */}
                {/* {allQData?.input_info?.quotationType !== "fanpad" &&
                  allQData?.input_info?.quotationType !== "nvph" &&
                  allQData?.input_info?.quotationType !== "nethouse" && (
                    <SoftwareServices image={image} />
                  )}
                {allQData &&
                  allQData?.input_info?.quotationType !== "hydroponics only" &&
                  allQData?.input_info?.quotationType !== "fanpad" &&
                  allQData?.input_info?.quotationType !== "nvph" &&
                  allQData?.input_info?.quotationType !== "nethouse" && (
                    <MaterialBreakdown />
                  )}
                {(allQData?.input_info?.quotationType === "fanpad" ||
                  allQData?.input_info?.quotationType === "nvph" ||
                  allQData?.input_info?.quotationType === "nethouse") && (
                  <MaterialBreakdownCEA />
                )}
                {allQData && (
                  <WorkOrderLocations
                    quotationType={allQData?.input_info?.quotationType}
                    image={image}
                  />
                )}
                <WarrantyOnMaterial /> */}
                {/* {data &&
                  allQData &&
                  (allQData?.input_info?.quotationType === "nvph" ||
                    allQData?.input_info?.quotationType === "nethouse" ||
                    allQData?.input_info?.quotationType ===
                      "nethouse with hydroponics" ||
                    allQData?.input_info?.quotationType ===
                      "nvph with hydroponics") && (
                    <>
                      <CheckTemprature SIData={data} />
                    </>
                  )} */}
                <KryzenTopQuot />
                {allQData?.quotationNumber?.includes("A/V2") ? (
                  <>
                    {" "}
                    {allQData && (
                      <QuotationAmountsV2
                        allQData={allQData}
                        quotationType={allQData?.input_info?.quotationType}
                      />
                    )}
                    {allQData && <PaymentBreakdownV2 allQData={allQData} />}
                  </>
                ) : (
                  <>
                    {allQData && (
                      <QuotationAmounts
                        allQData={allQData}
                        quotationType={allQData?.input_info?.quotationType}
                      />
                    )}
                    {allQData && <PaymentBreakdown allQData={allQData} />}
                  </>
                )}
                {/* {allQData && <AIFPaymentBreakdown allQData={allQData} />} */}
                {/* {allQData && (
                  <PaymentDetails
                    finalQuotation={allQData?.input_info?.finalQuotation}
                  />
                )} */}
              </div>
              {/* <div
                className="html2pdf__page-break"
                style={{
                  pageBreakAfter: "always",
                  display: "block",
                  clear: "both",
                }}
              ></div> */}
              {data &&
              allQData &&
              allQData?.input_info?.quotationType !== "fanpad" &&
              allQData?.input_info?.quotationType !== "nvph" &&
              allQData?.input_info?.quotationType !== "nethouse" &&
              allQData?.input_info?.quotationType !== "soilbasedfanpad" &&
              allQData?.input_info?.quotationType !== "soilbasednvph" &&
              allQData?.input_info?.quotationType !== "soilbasednethouse" &&
              data?.appliedForAIFDPR &&
              data?.borrowFromBank ? (
                <BorrowFromBankSchedule2 data={data} allQData={allQData} />
              ) : (
                ""
              )}

              {/* DPR */}
              {data &&
                allQData &&
                allQData?.input_info?.quotationType !== "fanpad" &&
                allQData?.input_info?.quotationType !== "nvph" &&
                allQData?.input_info?.quotationType !== "nethouse" &&
                allQData?.input_info?.quotationType !== "soilbasedfanpad" &&
                allQData?.input_info?.quotationType !== "soilbasednvph" &&
                allQData?.input_info?.quotationType !== "soilbasednethouse" && (
                  <div
                    className={
                      data?.appliedForAIFDPR && data?.borrowFromBank
                        ? "d-print-none"
                        : ""
                    }
                  >
                    <FinancialAnalysis data={data} allQData={allQData} />
                  </div>
                )}

              {data && <AIFSWOT data={data} />}
              {/* {data && <Promotion data={data} />} */}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};
export default SiteInspectionPreviewAIF;
